import PATHS from "./routes"
import FuelConsumptionEquipment from "../pages/scope1/FuelConsumptionEquipment";
import NaturalGasConsumptionLocation from "../pages/scope1/NaturalGasConsumptionLocation";
import VehicleUsageDistance from "../pages/scope1/VehicleUsageDistance";
import VehicleUsageFuel from "../pages/scope1/VehicleUsageFuel";
import RefrigerantConsumption from "../pages/scope1/RefrigerantConsumption"
import IndustrialGasConsumption from "../pages/scope1/IndustrialGasConsumption"
import ElectricityUsage from "../pages/scope2/ElectricityUsage";
import HeatSteamUsage from "../pages/scope2/HeatSteamUsage";
import PurchasedCooling from "../pages/scope2/PurchasedCooling";
import Scope3 from "../pages/scope3";
import FootprintAnalytics from "../pages/AnalyticsReductionTargets/FootprintAnalytics";
import ReductionTargetModeling from "../pages/AnalyticsReductionTargets/ReductionTargetModeling";
import BRSRReport from "../pages/GHGMetricReports/BRSRReport";
import ISSBGHGMetricReport from "../pages/GHGMetricReports/ISSBGHGMetricReport";
import UNFCCCReport from "../pages/GHGMetricReports/UNFCCCReport";
import GHGMethodologyReport from "../pages/GHGMetricReports/GHGMethodologyReport";
import CompanyDetails from "../pages/CompanyDetails";
import YearSetting from "../pages/YearSetting";
import LocationSetting from "../pages/LocationSetting";
import CompanyVehicles from "../pages/CompanyVehicles";
import CompanyEquipments from "../pages/CompanyEquipments";
import MyProfile from "../pages/MyProfile";
import ClimateProfile from "../pages/ClimateProfile";

import Category1 from "../components/scope3/AddSourcesDataModals/Category1";
import Category2 from "../components/scope3/AddSourcesDataModals/Category2";
import Category3 from "../components/scope3/AddSourcesDataModals/Category3";
import Category4 from "../components/scope3/AddSourcesDataModals/Category4";
import Category5 from "../components/scope3/AddSourcesDataModals/Category5";
import Category6A from "../components/scope3/AddSourcesDataModals/Category6A";
import Category6B from "../components/scope3/AddSourcesDataModals/Category6B";
import Category6C from "../components/scope3/AddSourcesDataModals/Category6C";
import Category6D from "../components/scope3/AddSourcesDataModals/Category6D";
import Category7 from "../components/scope3/AddSourcesDataModals/Category7";
import Category8 from "../components/scope3/AddSourcesDataModals/Category8";
import Category9 from "../components/scope3/AddSourcesDataModals/Category9";
import Category10 from "../components/scope3/AddSourcesDataModals/Category10";
import Category11 from "../components/scope3/AddSourcesDataModals/Category11";
import Category12 from "../components/scope3/AddSourcesDataModals/Category12";
import Category13 from "../components/scope3/AddSourcesDataModals/Category13";
import Category14 from "../components/scope3/AddSourcesDataModals/Category14";  
import Category15 from "../components/scope3/AddSourcesDataModals/Category15";

import Scope3TemplateMaster from "../pages/Masters/Scope3TemplateMaster";
import UserMaster from "../pages/Masters/UserMaster";

import EquipmentTypesMaster from "../pages/Masters/EquipmentTypesMaster";
import GeneralMaster from "../pages/Masters/GeneralMaster";
import SectorMaster from "../pages/Masters/SectorMaster";
import IndustryMaster from "../pages/Masters/IndustryMaster";
import SubIndustryMaster from "../pages/Masters/SubIndistryMaster";
import PrimaryUsageMaster from "../pages/Masters/PrimaryUsageMaster";
import PrimaryUsageTypeMaster from "../pages/Masters/PrimaryUsageTypeMaster";
import VehicleTypeMaster from "../pages/Masters/VehicleTypeMaster";
import VehicleSubTypeMaster from "../pages/Masters/VehicleSubTypeMaster";
import VehicleMakeMaster from "../pages/Masters/VehicleMakeMaster";
import VehicleModelMaster from "../pages/Masters/VehicleModelMaster";
import CountryMaster from "../pages/Masters/CountryMaster";
import StateMaster from "../pages/Masters/StateMaster";
import RefrigerantTypesMaster from "../pages/Masters/RefrigerantTypesMaster";
import FuelTypesMaster from "../pages/Masters/FuelTypesMaster";
import IndustrialGasMaster from "../pages/Masters/IndustrialGasMaster";

import Scope3DataSubmission from "../pages/Admin/Scope3DataSubmission";

import EmissionFuelMaster from "../pages/Masters/EmissionFuelMaster";
import EmissionIndGasMaster from "../pages/Masters/EmissionIndGasMaster";
import EmissionRefrigerantMaster from "../pages/Masters/EmissionRefrigerantMaster";
import CronLogs from "../pages/Admin/CronLogs";
import Scope3DataSubmissionCompany from "../pages/Admin/Scope3DataSubmissionCompany";
import EmissionVehicleDistanceWise from "../pages/Masters/EmissionVehicleDistanceWise";
import EmissionVehicleFuelWise from "../pages/Masters/EmissionVehicleFuelWise";
import EmissionNatGasMaster from "../pages/Masters/EmissionNatGasMaster";
import NaturalGasMaster from "../pages/Masters/NaturalGasMaster";
import EmissionElectricityMaster from "../pages/Masters/EmissionElectricityMaster";
import EmissionHeatSteamMaster from "../pages/Masters/EmissionHeatSteamMaster";
import EmissionPurchasedCoolingMaster from "../pages/Masters/EmissionPurchasedCoolingMaster";

 const routes = [
  { path: PATHS.ACCOUNTS_CLIMATE_PROFILE, element: <ClimateProfile /> ,protections:[]},
  { path: PATHS.ACCOUNTS_COMPANY_DETAILS, element: <CompanyDetails />,protections:[]},
  { path: PATHS.ACCOUNTS_YEAR_SETTING, element: <YearSetting /> , protections: ["companyDetails"]},
  { path: PATHS.ACCOUNTS_LOCATIONS, element: <LocationSetting /> , protections: ["year"]},
  { path: PATHS.ACCOUNTS_VEHICLES, element: <CompanyVehicles /> , protections: ["year"]},
  { path: PATHS.ACCOUNTS_EQUIPMENTS, element: <CompanyEquipments /> , protections: ["year"]},
  { path: PATHS.ACCOUNTS_MY_PROFILE, element: <MyProfile /> , protections: ["year"]},
    
  { path: PATHS.SCOPE_1_NATURAL_GAS_CONSUMPTION_LOCATION, element: <NaturalGasConsumptionLocation /> , protections: ["year"]},
  { path: PATHS.SCOPE_1_VEHICLE_USAGE_FUEL, element: <VehicleUsageFuel /> , protections: ["year"]},
  { path: PATHS.SCOPE_1_VEHICLE_USAGE_DISTANCE, element: <VehicleUsageDistance />, protections: ["year"] },
  { path: PATHS.SCOPE_1_FUEL_CONSUMPTION_EQUIPMENT, element: <FuelConsumptionEquipment /> , protections: ["year"]},
  { path: PATHS.SCOPE_1_REFRIGERANT_CONSUMPTION, element: <RefrigerantConsumption /> , protections: ["year"]},
  { path: PATHS.SCOPE_1_INDUSTRIAL_GAS_CONSUMPTION, element: <IndustrialGasConsumption /> , protections: ["year"]},

  { path: PATHS.SCOPE_2_ELECTRICITY_USAGE, element: <ElectricityUsage /> , protections: ["year"]},
  { path: PATHS.SCOPE_2_HEAT_STREAM_USAGE, element: <HeatSteamUsage /> , protections: ["year"]},
  { path: PATHS.SCOPE_2_PURCHASED_COOLING, element: <PurchasedCooling />, protections: ["year"] },

  { path: PATHS.SCOPE_3, element: <Scope3 />, protections: ["year"] },

  { path: PATHS.ANALYTICS_REDUCTION_FOOTPRINT_ANALYTICS, element: <FootprintAnalytics /> , protections: ["year"]},
  { path: PATHS.ANALYTICS_REDUCTION_REDUCTION_TARGET_MODEL, element: <ReductionTargetModeling /> , protections: ["year"]},

  { path: PATHS.METRIC_REPORT_GHG_METHODOLOGY, element: <GHGMethodologyReport /> , protections: ["year"]},
  { path: PATHS.METRIC_REPORT_IISB_GHG_METRIC, element: <ISSBGHGMetricReport /> , protections: ["year"]},
  { path: PATHS.METRIC_REPORT_UNFCCC_REPORT, element: <UNFCCCReport /> , protections: ["year"]},
  { path: PATHS.METRIC_REPORT_BRSR_REPORT, element: <BRSRReport /> , protections: ["year"]},

  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY1, element: <Category1 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY2, element: <Category2 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY3, element: <Category3 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY4, element: <Category4 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY5, element: <Category5 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY6A, element: <Category6A />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY6B, element: <Category6B />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY6C, element: <Category6C />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY6D, element: <Category6D />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY7, element: <Category7 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY8, element: <Category8 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY9, element: <Category9 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY10, element: <Category10 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY11, element: <Category11 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY12, element: <Category12 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY13, element: <Category13 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY14, element: <Category14 />, protections: ["year"]},
  {path: PATHS.ADD_EDIT_SOURCE_DATA_CATEGORY15, element: <Category15 />, protections: ["year"]},

  //Masters
  {path: PATHS.MASTERS_SCOPE3_TEMPLATE, element: <Scope3TemplateMaster /> ,protections:[]},
  {path:PATHS.MASTERS_USERS,element:<UserMaster/>,protections:[]},
  {path:PATHS.MASTERS_EQUIPMENT_TYPES,element:<EquipmentTypesMaster/>,protections:[]},
  {path:PATHS.MASTERS_GENERAL,element:<GeneralMaster/>,protections:[]},
  {path:PATHS.MASTERS_SECTOR,element:<SectorMaster/>,protections:[]},
  {path:PATHS.MASTERS_INDUSTRY,element:<IndustryMaster/>,protections:[]},
  {path:PATHS.MASTERS_SUBINDUSTRY,element:<SubIndustryMaster/>,protections:[]},
  {path:PATHS.MASTERS_PRIMARY_USAGE,element:<PrimaryUsageMaster/>,protections:[]},
  {path:PATHS.MASTERS_PRIMARY_USAGE_TYPE,element:<PrimaryUsageTypeMaster/>,protections:[]},
  {path:PATHS.MASTERS_VEHICLE_TYPE,element:<VehicleTypeMaster/>,protections:[]},
  {path:PATHS.MASTERS_VEHICLE_SUB_TYPE,element:<VehicleSubTypeMaster/>,protections:[]},
  {path:PATHS.MASTERS_VEHICLE_MAKE,element:<VehicleMakeMaster/>,protections:[]},
  {path:PATHS.MASTERS_VEHICLE_MODEL,element:<VehicleModelMaster/>,protections:[]},
  {path:PATHS.MASTERS_COUNTRY,element:<CountryMaster/>,protections:[]},
  {path:PATHS.MASTERS_STATES,element:<StateMaster/>,protections:[]},
  {path:PATHS.MASTERS_INDUSTRIAL_GAS,element:<IndustrialGasMaster/>,protections:[]},
  {path:PATHS.MASTERS_NATURAL_GAS,element:<NaturalGasMaster/>,protections:[]},
  {path:PATHS.MASTERS_REFRIGERANT_TYPES,element:<RefrigerantTypesMaster/>,protections:[]},
  {path:PATHS.MASTERS_FUEL_TYPES,element:<FuelTypesMaster/>,protections:[]},

  {path:PATHS.SCOPE3_DATA_SUBMISSION, element:<Scope3DataSubmission/>,protections:[]},
  {path:PATHS.SCOPE3_DATA_SUBMISSION_COMPANY, element:<Scope3DataSubmissionCompany/>,protections:[]},
  {path:PATHS.CRON_LOGS,element:<CronLogs/>,protections:[]},
  
  {path:PATHS.MASTERS_FUEL_EMISSION,element:<EmissionFuelMaster/>,protections:[]},
  {path:PATHS.MASTERS_INDUSTRIAL_GAS_EMISSION,element:<EmissionIndGasMaster/>,protections:[]},
  {path:PATHS.MASTERS_NATURAL_GAS_EMISSION,element:<EmissionNatGasMaster/>,protections:[]},
  {path:PATHS.MASTERS_REFRIGERANT_EMISSION,element:<EmissionRefrigerantMaster/>,protections:[]},
  {path:PATHS.MASTERS_VEHICLE_DISTANCE_WISE_EMISSION,element:<EmissionVehicleDistanceWise/>,protections:[]},
  {path:PATHS.MASTERS_VEHICLE_FUEL_WISE_EMISSION,element:<EmissionVehicleFuelWise/>,protections:[]},

  {path:PATHS.MASTERS_ELECTRICITY_EMISSION,element:<EmissionElectricityMaster/>,protections:[]},
  {path:PATHS.MASTERS_HEAT_STEAM_EMISSION,element:<EmissionHeatSteamMaster/>,protections:[]},
  {path:PATHS.MASTERS_PURCHASED_COOLING_EMISSION,element:<EmissionPurchasedCoolingMaster/>,protections:[]},
];

export default routes